var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCoHost(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u56FE\u6807/\u6307\u793A\u7C7B/\u4E3B\u6301\u4EBA\u8054\u5E2D/normal") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u6807/\\u6307\\u793A\\u7C7B/\\u4E3B\\u6301\\u4EBA\\u8054\\u5E2D/normal",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u6807/\\u6307\\u793A\\u7C7B/\\u8054\\u5E2D\\u4E3B\\u6301\\u4EBA",
    fill: "#006FFF"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.167841,9.97501614 C14.365295,10.8268174 15.9361514,12.9355624 15.9981001,15.4189412 L16,16 L4,16 L4.00189993,15.4189412 C4.06384863,12.9355624 5.63470496,10.8268174 7.83215899,9.97501614 L10,12.1428571 L12.167841,9.97501614 Z M10,4 C11.4201608,4 12.5714286,5.15126779 12.5714286,6.57142857 C12.5714286,7.9542167 11.4799565,9.08207789 10.1115432,9.14048139 L10,9.14285714 L9.88845677,9.14048139 C8.52004345,9.08207789 7.42857143,7.9542167 7.42857143,6.57142857 C7.42857143,5.15126779 8.57983921,4 10,4 Z",
    id: "\\u5F62\\u72B6\\u7ED3\\u5408",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCoHost);
export default __webpack_public_path__ + "static/media/icon_co_host.f032a4f0a4401733c9c057f91643019d.svg";
export { ForwardRef as ReactComponent };